var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticStyle:{"width":"100%","height":"298px"},attrs:{"id":"trend"}})}
var staticRenderFns = []

export { render, staticRenderFns }